function fbLoginDirective(LoginService, $rootScope, AlertService) {
    'ngInject';

    return {
        restrict: 'A',
        scope: true,
        link(scope, element, attrs) {

            const options = scope.$eval(attrs.bbFbLogin) || {};
            $rootScope.connection_started.then(() => checkLoginState());

            const statusChangeCallback = function (response) {
                if (response.status === 'connected') {
                    const params = {};
                    params.access_token = response.authResponse.accessToken;
                    if (options.login_only) {
                        params.login_only = options.login_only;
                    }
                    loginToBBWithFBUser(params);
                } else if (response.status === 'not_authorized') {
                    scope.loginFB();
                } else {
                    scope.loginFB();
                }
            };

            const checkLoginState = function () {
                FB.getLoginStatus((response) => {
                    statusChangeCallback(response);
                });
            };

            const loginToBBWithFBUser = params =>
                LoginService.FBLogin(scope.bb.company, params).then((member) => {
                        $rootScope.member = member;
                        scope.setClient($rootScope.member);
                        if (scope.bb.destination) {
                            return scope.redirectTo(scope.bb.destination);
                        } else {
                            scope.setLoaded(scope);
                            return scope.decideNextPage();
                        }
                    }
                    , (err) => {
                        if (err.data.error === 'FACEBOOK-LOGIN-MEMBER-NOT-FOUND') {
                            return AlertService.raise('FB_LOGIN_NOT_A_MEMBER');
                        } else {
                            return AlertService.raise('LOGIN_FAILED');
                        }
                    })
            ;


            scope.loginFB = () =>
                FB.login(((response) => {
                    if (response.status === 'connected') {
                        const params = {};
                        params.access_token = response.authResponse.accessToken;
                        if (options.login_only) {
                            params.login_only = options.login_only;
                        }
                        loginToBBWithFBUser(params);
                    } else if (response.status === 'not_authorized') {
                        AlertService.raise('LOGIN_FAILED');
                    } else {
                        AlertService.raise('LOGIN_FAILED');
                    }
                }), {scope: 'public_profile,email'})
            ;
        }
    };
}

angular
    .module('BB')
    .directive('bbFbLogin', fbLoginDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/fb-login/fb_login.directive.js